import React from 'react';
import {TablePagination} from "@mui/material";
import './TablePage.css';


const tablePage = (props) => {
  const disableClick = (e) => {
    if(props.refresh_list && e.key === "Enter"){
      e.preventDefault();
    }
  }
    return <>
    <div className = 'page-num-align' onKeyPress = {(e) => disableClick(e)}>
      <TablePagination
            component="div"
            count= {props.count}
            rowsPerPageOptions={props.rowsPerPageOptions || [15]}
            rowsPerPage={props.recordsPerPage}
            page={props.pageNum}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: false,
            }}
            sx={{
              color: "var(--text-primary)",
              "svg": {
                color: "var(--text-grey)",
              },
              "button": {
                color: "var(--text-title)"
              }
            }}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
            onPageChange={props.handleChangePage}
            slotProps={{
              select: {
                MenuProps: {
                  PaperProps: {
                    sx: {
                      backgroundColor: "var(--bg-popover)",
                      borderRadius: "8px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
          
                      /* Menu items */
                      "& .MuiMenuItem-root": {
                        color: "var(--text-grey)",
                        fontSize: "14px",
          
                        "&:hover": {
                          backgroundColor: "var(--bg-popover-hover)",
                        },
                      },
                    },
                  },
                },
              },
            }}
          />
          <div className = 'page-box'>
            <p> {props.pageNum+1}</p>  
          </div>
          </div>
          </>;
            
}

export default tablePage;